export function roundToMonth(num: number | undefined, decimalPlaces: number): number {
  // if (!periodMonth) periodMonth = 12; // Default to 12 months if not provided
  return getMonthlyPrice(num, decimalPlaces, 12);
}

export function getMonthlyPrice(
  num: number | undefined,
  decimalPlaces: number,
  periodCount: number
): number {
  if (num === undefined) {
    return 0;
  }

  return (
    Math.round((num / periodCount) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)
  );
}
